var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "payment-item",
    class: {
      'bottom-dashed-line': !_vm.last
    },
    on: {
      "click": _vm.toEdit
    }
  }, [_c('ul', {
    staticClass: "info-cont"
  }, [(!_vm.is_trans) ? _c('li', [_c('span', {
    staticClass: "label"
  }, [_vm._v("付款方式")]), _c('span', [_vm._v(_vm._s(_vm.payment.vendor_title))])]) : _vm._e(), _vm._v(" "), (_vm.is_trans) ? _c('li', [_c('span', {
    staticClass: "label"
  }, [_vm._v("付款方式")]), _c('span', [_vm._v("转账")]), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.allowEdit),
      expression: "allowEdit"
    }],
    staticClass: "payment-edit yellow"
  }, [_vm._v("修改")])]) : _vm._e(), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "label"
  }, [_vm._v("付款金额")]), _c('span', [_vm._v(_vm._s(_vm.payment.amount) + "元")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "label"
  }, [_vm._v("付款日期")]), _c('span', [_vm._v(_vm._s(_vm.paid_time))])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "label"
  }, [_vm._v("付款状态")]), _c('span', {
    staticClass: "yellow"
  }, [_vm._v(_vm._s(_vm.payment.pay_status_title))])]), _vm._v(" "), (_vm.is_trans) ? _c('li', [_c('span', {
    staticClass: "label"
  }, [_vm._v("转入账户")]), _c('span', [_vm._v(_vm._s(_vm.payment.payment_way))])]) : _vm._e(), _vm._v(" "), (_vm.is_trans && _vm.payment.bank_name) ? _c('li', [_c('span', {
    staticClass: "label"
  }, [_vm._v("付款银行")]), _c('span', [_vm._v(_vm._s(_vm.payment.bank_name))])]) : _vm._e(), _vm._v(" "), (_vm.is_trans && _vm.payment.bank_account_name) ? _c('li', [_c('span', {
    staticClass: "label"
  }, [_vm._v("付款账户")]), _c('span', [_vm._v(_vm._s(_vm.payment.bank_account_name))])]) : _vm._e(), _vm._v(" "), (_vm.has_trade_no) ? _c('li', [_c('span', {
    staticClass: "label"
  }, [_vm._v("付款单号")]), _c('span', [_vm._v(_vm._s(_vm.payment.trade_no))])]) : _vm._e(), _vm._v(" "), (_vm.has_alipayid) ? _c('li', [_c('span', {
    staticClass: "label"
  }, [_vm._v("付款账号")]), _c('span', [_vm._v(_vm._s(_vm.payment.alipay_id))])]) : _vm._e()])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@13.0.2@vue-loader/lib/template-compiler?{"id":"data-v-71eb98f4","hasScoped":true}!./~/_vue-loader@13.0.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/OrderPayItem.vue
// module id = 240
// module chunks = 0